import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Modal from "src/components/Modal"

const DiscardConfirmModal = ({
  isOpen,
  onKeepEditing,
  onDiscard,
  title = "Discard unsaved changes?",
  message = "You have unsaved changes. Close this form and discard them?",
  keepEditingLabel = "Keep editing",
  discardLabel = "Discard changes",
}) => {
  if (!isOpen) return null

  return (
    <Modal isOpen={isOpen} onClose={onKeepEditing} size="small" stacked>
      <Modal.Header title={title} />
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-end gap-2">
          <Button variant="secondary" type="button" onClick={onKeepEditing}>
            {keepEditingLabel}
          </Button>
          <Button variant="primary" type="button" onClick={onDiscard}>
            {discardLabel}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

DiscardConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  keepEditingLabel: PropTypes.string,
  discardLabel: PropTypes.string,
}

export default DiscardConfirmModal
